import { Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Label, Panel, Radio } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import { IValidation } from './validation';
import { AboType, Gender } from '@nkr/enums/index';
import { FormEvent } from 'react';
import { IListItem } from '@nkr/models/index';

interface IProps {
    donorUnosId: string,
    donorAlias: string,
    donorEmail: string,
    donorAboType: number,
    donorGender: number,
    donorName: string,
    donorAddressLine1: string,
    donorAddressLine2: string,
    donorCity: string,
    donorState: number,
    donorPostalCode: string,
    donorPhoneNumber: string,
    donorBirthdate: string,
    validation: IValidation,
    dirty: boolean,
    stateList: IListItem[],
    onDataChange: (field: string, value: any) => void,
    onDonorEmailBlur?: () => void
}

const DonorDetails = (props: IProps) => {
    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { id, value } = e.currentTarget;
        props.onDataChange(id, value);
    };

    return (
        <Panel>
            <Panel.Heading>Donor Details</Panel.Heading>
            <Panel.Body>
                <Form horizontal>
                    <FormGroup validationState={props.dirty && !props.validation.donorUnosId ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's UNOS ID:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='donorUnosId'
                                maxLength={7}
                                value={props.donorUnosId}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Alias:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='donorAlias'
                                value={props.donorAlias}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorEmail ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Email:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='donorEmail'
                                value={props.donorEmail}
                                onChange={handleFieldChange}
                                onBlur={props.onDonorEmailBlur}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorAboType ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's ABO:</Col>
                        <Col xs={12} lg={6}>
                            <Radio inline id='donorAboType' name='donorAboType' value={AboType.O} checked={props.donorAboType == AboType.O} onChange={handleFieldChange}>O</Radio>
                            <Radio inline id='donorAboType' name='donorAboType' value={AboType.A} checked={props.donorAboType == AboType.A} onChange={handleFieldChange}>A</Radio>
                            <Radio inline id='donorAboType' name='donorAboType' value={AboType.B} checked={props.donorAboType == AboType.B} onChange={handleFieldChange}>B</Radio>
                            <Radio inline id='donorAboType' name='donorAboType' value={AboType.Ab} checked={props.donorAboType == AboType.Ab} onChange={handleFieldChange}>AB</Radio>
                            <Radio inline id='donorAboType' name='donorAboType' value={AboType.Unknown} checked={props.donorAboType == AboType.Unknown} onChange={handleFieldChange}>Unknown</Radio>
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorGender ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Gender:</Col>
                        <Col xs={12} lg={6}>
                            <Radio inline id='donorGender' name='donorGender' value={Gender.Male} checked={props.donorGender == Gender.Male} onChange={handleFieldChange}>M</Radio>
                            <Radio inline id='donorGender' name='donorGender' value={Gender.Female} checked={props.donorGender == Gender.Female} onChange={handleFieldChange}>F</Radio>
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorName ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Name:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='donorName'
                                value={props.donorName}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorAddressLine1 ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Address (line 1):</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='donorAddressLine1'
                                value={props.donorAddressLine1}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Address (line 2):
                            &nbsp;<Label bsStyle='default' >optional</Label></Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='donorAddressLine2'
                                value={props.donorAddressLine2}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorCity ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's City:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='donorCity'
                                value={props.donorCity}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorState ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's State:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                componentClass='select'
                                id='donorState'
                                value={props.donorState}
                                onChange={handleFieldChange}
                            >
                                <option value={0}>- Please Select -</option>
                                {props.stateList.map(item =>
                                    <option key={'state-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorPostalCode ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Postal Code:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                id='donorPostalCode'
                                maxLength={10}
                                value={props.donorPostalCode}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorPhoneNumber ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Phone:</Col>
                        <Col xs={12} lg={6}>
                            <MaskedInput
                                id='donorPhoneNumber'
                                className='form-control'
                                mask='(111) 111-1111'
                                placeholder='(XXX) XXX-XXXX'
                                style={{ borderColor: props.validation.donorPhoneNumber ? '#ccc' : '#a94442' }}
                                value={props.donorPhoneNumber}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.donorBirthdate ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Donor's Birthdate:</Col>
                        <Col xs={12} lg={6}>
                            <MaskedInput
                                id='donorBirthdate'
                                className='form-control'
                                mask='11/11/1111'
                                placeholder='mm/dd/yyyy'
                                style={{ borderColor: props.validation.donorBirthdate ? '#ccc' : '#a94442' }}
                                value={props.donorBirthdate}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default DonorDetails;